import { Lock } from "lucide-react";

/* Neo-Brutalist founder-only financial compliance gate. Rendered over any
   financial / banking / tax sub-surface for non-founder accounts. Fits the
   Galaxy S20 chassis (no horizontal overflow) — flat black offset shadow,
   hard 2px border, zero gradients/blur. */
export default function FinancialLockGate({ testid = "financial-lock-gate" }) {
  return (
    <div
      data-testid={testid}
      className="mt-3 w-full max-w-full border-2 border-black bg-[#FFC24B] rounded-none shadow-[4px_4px_0px_#000] p-4"
    >
      <div className="flex items-center gap-2">
        <span className="shrink-0 grid place-items-center w-9 h-9 border-2 border-black bg-black">
          <Lock size={16} className="text-[#FFC24B]" />
        </span>
        <h3
          data-testid="financial-lock-heading"
          className="font-mono text-[13px] font-black uppercase tracking-tight text-black leading-none break-words"
        >
          FEATURE LOCKED // RESTRICTED ACCESS
        </h3>
      </div>
      <p
        data-testid="financial-lock-subtext"
        className="mt-3 border-2 border-black bg-white px-3 py-2 font-mono text-[10px] leading-relaxed text-black break-words"
      >
        Misteck financial and vault systems are currently undergoing regulatory
        compliance sandbox verification. Public utility will resume following
        legal clearance.
      </p>
    </div>
  );
}
